import AFRAME from "aframe";

AFRAME.registerComponent('tooltip', {
    dependencies: [],
    schema: {type: 'string', default: 'Some tooltip content'},
    init() {
        const me = this;
        me.positionSystem = document.querySelector('a-scene').systems['position'];
        me.animations = document.querySelector('a-scene').systems['animations'];

        const tooltip = document.getElementById('tooltip');
        const tooltipContent = document.getElementById('tooltip_content');

        if (!tooltip || !tooltipContent) {
            return;
        }

        me.el.addEventListener('mouseenter', () => {

            me.ival = setTimeout(function() {
                let tooltipHTML = me.data;

                if (tooltipHTML) {
                    me.positionSystem.aboveElement(tooltip, me.el);

                    tooltip.addEventListener("rendered", function() {
                        me.animations.show(tooltip, '');
                    }, {once : true});

                    tooltipContent.components.html.setHtml(tooltipHTML);

                }
            },1000);
        });

        me.el.addEventListener('mouseleave', () => {
            if (me.ival) {
                clearInterval(me.ival);
                me.ival = null;
            }
            tooltipContent.components.html.setHtml('');
            me.animations.hide(tooltip, '');
        });

    },
});

AFRAME.registerComponent('showline', {
    dependencies: [],
    schema: {type: 'vec3'},
    init() {
        const me = this;

        const line = document.getElementById('line');

        me.el.addEventListener('mouseenter', () => {
            const sky = document.getElementById('sky');

            const iconPosition = me.el.object3D.getWorldPosition(new THREE.Vector3());
            const skyPosition = me.data;

            const s = new THREE.Spherical();
            s.setFromVector3(skyPosition);
            s.radius = 500;

            const newPosition = new THREE.Vector3();
            newPosition.setFromSpherical(s);
            newPosition.y += 1.6

            line.setAttribute('line', {start: iconPosition, end: newPosition});
            line.setAttribute('advanced-visible', true);
        });

        me.el.addEventListener('mouseleave', () => {
            line.setAttribute('advanced-visible', false);
        });

    },
});